import { CompareHelper } from '@barthauer/abc/core';
import { MapStyle } from './map.model';

export class LayerItemNode {
  children: LayerItemNode[];
  key: string;
  displayText: string;
  layer: any;
  style: MapStyle;
  collapsedByDefault: boolean;
}

export class LayerItemFlatNode {
  get key(): string {
    return this.node.key;
  }
  get displayText(): string {
    return this.node.displayText;
  }
  get layer(): any {
    return this.node.layer;
  }
  get expandable(): boolean {
    return !CompareHelper.isNullorEmpty(this.node.children?.length) || (this.node.layer?.getLayers && this.node.layer?.getLayers().length === 0);
  }
  get expandDisabled(): boolean {
    return !this.node.children?.length;
  }

  level: number;

  constructor(public readonly node: LayerItemNode) {}
}
